module.exports = __webpack_public_path__ + "img/duracion_cortos_seleccionado.9d5b4a51.png";